import { Alert, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

const GridStyle = {
  width: '65%',
  display: 'flex',
  justifyContent: 'flex-end',
};

const AlertCustomStyle = {
  textAlign: 'center',
  height: '80px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '50%',
  fontSize: '18px',
};

//Show alert message for error on UI using ErrorAlert
export const ErrorAlert = ({ message = '' }) => {
  const { t } = useTranslation();

  return (
    <Grid style={GridStyle}>
      <Alert severity="error" style={AlertCustomStyle}>
        {t(message)}
      </Alert>
    </Grid>
  );
};
